import { EngagementCampaignStatus } from '@anytag/graphql';
import { Badge, BadgeProps } from '@anyui/core';
import { useEngagementStatusOptions } from '../hooks';

export interface EngagementStatusProps {
  className?: string;
  status?: EngagementCampaignStatus;
}

export const EngagementStatus = ({ status, className }: EngagementStatusProps) => {
  const { engagementStatusOptions } = useEngagementStatusOptions();

  const children = engagementStatusOptions.find((o) => o.value === status)?.label || '';
  const statusProps = ((): BadgeProps => {
    switch (status) {
      case EngagementCampaignStatus.DRAFT:
        return { children, color: 'yellow' };
      case EngagementCampaignStatus.REVIEWING:
        return { children, color: 'purple' };
      case EngagementCampaignStatus.UPCOMING:
        return { children, color: 'blue' };
      case EngagementCampaignStatus.ONGOING:
        return { children, color: 'green' };
      case EngagementCampaignStatus.LOST:
        return { children, color: 'red' };
      case EngagementCampaignStatus.DEMO:
        return { children, color: 'cyan' };
      default:
        return { children, color: 'zinc' };
    }
  })();

  return <Badge {...statusProps} className={className} />;
};
